import { render, staticRenderFns } from "./FilePondInput.vue?vue&type=template&id=66c8dd93&"
import script from "./FilePondInput.vue?vue&type=script&lang=js&"
export * from "./FilePondInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports